import React from 'react'
import { Spacer, WorkArea } from '@revelrygroup/components'

import { Case } from '../../../types'
import FlowerRow from '../../FlowerRow'
import { NoServices } from '../../NoServices'
import Obituary from '../../models/Obituary'
import { Service } from '../../Service'
import styles from '../styles.module.scss'
import useFlowerProductsContext from '../../../hooks/useFlowerProductsContext'

interface Props {
  theCase: Case | null
  timeZone: string
}

const ServicesPage: React.FC<Props> = ({ theCase, timeZone }) => {
  const services = theCase.case_service_offerings.filter((service) => !!service.venue)
  const { products } = useFlowerProductsContext()

  return (
    <>
      <WorkArea avoidHeader className={styles.workarea}>
        <Spacer verticalBottom="sm">
          <h1 className="h3 centered-text">{Obituary.deceasedFullName(theCase)} Services</h1>
        </Spacer>

        {services.length > 0 ? (
          services.map((service) => (
            <Service key={service.id} obituary={theCase} service={service} timeZone={timeZone} />
          ))
        ) : (
          <NoServices obituary={theCase} />
        )}
      </WorkArea>

      {theCase.enable_flowerstore && products.length > 0 && (
        <FlowerRow obituary={theCase} products={products.slice(0, 11)} />
      )}
    </>
  )
}

export default ServicesPage
